import React from 'react'
import PageHeaderComponent from '@components/page/pageHeader.component'
import PlaylistFormComponent from '@components/playlist/playlistForm.component'
import AppPageComponent from '@components/page/appPage.component'
import PageBodyComponent from '@components/page/pageBody.component'
import BreadcrumbsComponent from '@components/shared/breadcrumbs.component'

const PlaylistFormPage: React.FC = () => {
  return (
    <AppPageComponent>
      <PageHeaderComponent>
        <BreadcrumbsComponent></BreadcrumbsComponent>
      </PageHeaderComponent>
      <PageBodyComponent>
        <PlaylistFormComponent />
      </PageBodyComponent>
    </AppPageComponent>
  )
}
export default PlaylistFormPage
